var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.approved
    ? _c(
        "v-tooltip",
        {
          attrs: { bottom: "" },
          scopedSlots: _vm._u(
            [
              {
                key: "activator",
                fn: function({ on, attrs }) {
                  return [
                    _c(
                      "v-icon",
                      _vm._g(
                        _vm._b(
                          { attrs: { color: "success", dark: "" } },
                          "v-icon",
                          attrs,
                          false
                        ),
                        on
                      ),
                      [_vm._v(" mdi-check ")]
                    )
                  ]
                }
              }
            ],
            null,
            false,
            3454848358
          )
        },
        [_c("span", [_vm._v("Approved")])]
      )
    : _c(
        "v-tooltip",
        {
          attrs: { bottom: "" },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function({ on, attrs }) {
                return [
                  _c(
                    "v-icon",
                    _vm._g(
                      _vm._b(
                        { attrs: { color: "warning", dark: "" } },
                        "v-icon",
                        attrs,
                        false
                      ),
                      on
                    ),
                    [_vm._v(" mdi-alert ")]
                  )
                ]
              }
            }
          ])
        },
        [_c("span", [_vm._v("Not Approved")])]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }